 <template>

    <div @click="$sidebar.displaySidebar(false)">
        <div class="row">
                <div class="col-xl-8 mb-0 mb-xl-0">
                    <div class="card shadow">
                        <div class="card-body">
                          <h4 class="mb-3">下書き詳細</h4>
                          <div>
                              <transition name="slide-fade">
                              <div class="alert alert-success" v-if="info" >{{ info }}</div>
                            </transition>

                              <div class="form-group" v-bind:class="{  'text-danger has-error': errors.title }">
                                  <label for="title">タイトル<span class="badge badge-required">必須</span></label>
                                  <input type="text" v-model="title" class="form-control" name="title" id="title" />
                                    <p v-for="(error,key) in errors.title" :key="key" class="error-text" >{{error}}</p>
                              
                              </div>
                              <div class="form-group"  v-bind:class="{  'text-danger has-error': errors.url }">
                                  <label for="url">遷移先URL<span class="badge badge-required">必須</span></label>
                                  <input type="url" v-model="url" class="form-control" name="url" id="url" />
                                  <p v-for="(error,key) in errors.url" :key="key" class="error-text" >{{error}}</p>
                              </div>

                              <div class="form-group"  v-bind:class="{  'text-danger has-error': errors.message }">
                                  <label for="message">メッセージ本文<span class="badge badge-required">必須</span></label>
                                  <textarea class="form-control" v-model="message" name="message" id="message" rows="5"></textarea>
                                  <p v-for="(error,key) in errors.message" :key="key" class="error-text" >{{error}}</p>
                              </div>

                              <div class="form-group">
                                  <label for="image">サムネイル画像<span class="badge badge-option">任意</span></label>
                                  <dropzone-file-upload v-model="fileSingle" :options="options" :serverImageUrl="image"></dropzone-file-upload>
                                  <small class="form-text text-muted">※推奨サイズ：256x256, 画像形式：png, jpg</small>
                                  <p v-for="(error,key) in errors.file" :key="key" class="error-text" >{{error}}</p>  
                              </div>

                                <div class="form-group" v-show="hasCategory">
                                <label >カテゴリー<span class="badge badge-required">必須</span></label>
                                <ul  class="checkbox-container">
                                    <li class="form-check" v-for="(choice,key) in choices" :key="key">
                                      <input type="checkbox"  v-model="categorySelected"  :value="choice.category_value" class="form-check-input"  :id="choice.category_value"  :checked="choice.checked" />
                                      <label class="form-check-label" :for="choice.category_value">{{ choice.category_label }}</label>
                                    </li>
                                </ul>
                                 <p v-for="(error,key) in errors.category" :key="key" class="error-text" >{{error}}</p>
                              </div>

                              <div class="form-group" >
                                <label >配信時間<span class="badge badge-required" v-show="showSchedule">必須</span></label>
                                <ul class="radio-container">
                                  <li>
                                    <base-radio class="mb-3" name="now" v-model="radio" :inline="true">
                                      今すぐ配信
                                    </base-radio>
                                  </li>                             
                                  <li>
                                    <base-radio class="mb-3" name="schedule" v-model="radio" :inline="true">
                                        予約配信
                                    </base-radio>
                                  </li>
                                </ul>
                                
                              </div>

                              <div class="form-group" v-show="showSchedule" v-bind:class="{  'text-danger has-error': scheduleErrorMsg }">
                                <label for="datepicker">配信日時<span class="badge badge-required">必須</span></label>
                                  <div class="form-row">
                                    <div class="form-inline col-md-3 date-select">
                                      <datepicker :format="customFormatter" :disabledDates="disabledDates"  :language="ja" v-model="reservationDate" :input-class="'form-control'" ></datepicker>  
                                    </div>
                                    <div class="form-inline col-md-2 hour-select">
                                      <select v-model="reservationHour" class="form-control"> 
                                        <option value="00" >00</option>
                                        <option  v-for="n in 24" :value="n.toString().padStart(2, '0')" :key="n">{{n.toString().padStart(2, '0')}}</option>
                                      </select>
                                    </div>
                                    <div class="form-inline col-md-2 minute-select">
                                      <label>:</label>
                                      <select v-model="reservationMinute"  class="form-control "> 
                                        <option value="00">00</option>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                        <option value="40">40</option>
                                        <option value="50">50</option>
                                      </select>
                                    </div>
                                  </div>
                                   <p v-for="(error,key) in errors.reservation_at" :key="key" class="error-text" >{{error}}</p>
                                   <p class="error-text" >{{ scheduleErrorMsg }}</p>
                              </div>
                              <!--
                              <div class="form-group">
                                <label>テスト配信<span class="badge badge-required">必須</span></label>
                                <base-switch class="mr-1" on-text="On" off-text="Off" :value="isTest" v-model="isTest"></base-switch>
                                <small class="form-text text-muted">※テスト配信をONにすると、テストユーザーにのみ配信されます。</small>
                              </div>
                            -->
                              <div class="btn-wrap form-group text-center">
                                <button  class="btn btn-primary btn-white" @click="update"  :disabled="loading" >下書き保存する</button>
                                <button  v-show="showsend" class="btn btn-primary" @click="send"  :disabled="loading" >{{ isSchedule ? '配信予約する': '配信する'  }}</button>
                              </div>
                          </div>
                        </div>
                    </div>
                </div>
        </div>
        <modal :show.sync="showLimitModal" @close="closeModal" class="limit-exceed">
              <h4 slot="header" class="modal-title">プランの変更が必要です。</h4>
              <div class="">
                <p v-html="limitExceedInfo.modal_text" class="error-txt"></p>
              </div>
              <div class="form-group text-center"><base-button  id="card-button" type="primary" @click="changePlan()">{{ limitExceedInfo.button_txt }}</base-button></div>
        </modal>

    </div>
        
</template>

<script>

import Datepicker from 'vuejs-datepicker'
import {ja} from 'vuejs-datepicker/dist/locale'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import DropzoneFileUpload from './PushlDropzoneFileUpload'


export default {
  name: "notification-update",
  props: ['notification', 'checkboxesData','disabled', 'cat_by_subscription','limit_exceed'],
  components: { Datepicker, moment, DropzoneFileUpload},
  name: "notification-registration",
  data() {
    return {
      options:{
        dictDefaultMessage:"アップロード",
        
      },
      hasCategory:false,
      siteId:0,
      //isSMS: false,
      //isTest:true,
      isTest:false,
      message:'',
      title: '',
      url: '',
      errors: {},
      image:'',
      fileSingle: [],
      loading: false,
      isSend: 0,
      radio:"",
      scheduleErrorMsg:"",
      showSchedule:false,
      info:null,
      choices:null,
      categorySelected: [],
      reservationDate:'',
      reservationHour: '00',
      reservationMinute: '00',
      disabledDates: {
      	 to: new Date(Date.now() - 8640000) 
       },
       ja:ja,
       showLimitModal:false,
       limitExceedInfo: {
            doesExceded: 0,
            is_subscriber_limit: 0,
            is_send_limit: 0,
            modal_text: "",
            button_link: "",
            button_txt:  "",
       }
    }
  },
   computed: {
      isSchedule:function(){
        if(this.radio=='schedule') {
          this.reservationDate= ''
          this.reservationHour= '00'
          this.reservationMinute ='00'
          this.showSchedule=true
          return true;
        }
        this.showSchedule=false
        return false;
      },
      showsend:function(){
        return this.radio=='schedule' || this.radio=='now'
      },
       theNotification: function(){
            return JSON.parse(this.notification);
        },
        theCheckboxes: function() {
            var parsed = JSON.parse(this.checkboxesData);
            
            for(var i=0; i<parsed.length; i++) {
              if(parsed[i].checked) {
            	  this.categorySelected.push(parsed[i].category_value)
            	}
            }
            
        	return parsed;	
        }
    },
    mounted() {
      this.siteId = window.PushL.site_id
      this.id = this.theNotification.id
      this.title = this.theNotification.title
      this.message = this.theNotification.message
      this.url = this.theNotification.url
      this.image = this.theNotification.image
      console.log(this.cat_by_subscription)
      this.limitExceedInfo = {...this.limitExceedInfo, ...JSON.parse(this.limit_exceed)}
      if(this.limitExceedInfo.doesExceded) {
        this.showLimitModal = true
      }
 
      this.fileSingle = []
      this.choices = this.theCheckboxes
      if(this.choices.length) {
        this.hasCategory = true
      }
      if(this.theNotification.reservation_at) {
        this.radio="schedule"
        this.showSchedule=true
        const date = new Date(this.theNotification.reservation_at*1000);
        this.reservationDate = date.toISOString().slice(0,10);
        this.reservationHour = date.getHours();
        this.reservationMinute =date.getMinutes();
      }
     
    },
  methods: {
    customFormatter(date) {
      return moment(date).format('YYYY年MM月DD日');
    },
    resetFields() {
      this.message= "";
      this.title= "";
      this.url= "";
      this.image= "";
      this.fileSingle= [];
      this.isSend= 0;
      //this.isTest=true;
      this.isTest=false;
    },
    changePlan() {
      window.location.href= this.limitExceedInfo.button_link;
    },
    closeModal() {
     this.showLimitModal = false
    },
    /*resetFields() {
        this.$data.message= "";
        this.$data.title= "";
        this.$data.url= "";
        this.$data.image= "";
        this.$data.fileSingle= [];
        this.$data.isSend= 0;
        this.$data.isSMS=false;
        //this.$data.isTest=true;
        this.$data.isTest=false;
    },*/
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length)
          return;
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
          vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
            
    send() {
      this.loading = true;
      this.errors = {};
      this.isSend = 1;
      this.update();
    },
    update() {
      if(this.limitExceedInfo.doesExceded) {
        this.showLimitModal = true
        return
      } else {
        this.loading = true;
        this.errors = {};
        console.log("image")
        if((this.fileSingle).length && this.fileSingle[(this.fileSingle).length-1].dataURL) {
          this.image = this.fileSingle[(this.fileSingle).length-1].dataURL;
        }

      /* let reservationAt = ""
        if(this.reservationDate) {
          reservationAt = moment(this.reservationDate).format('YYYY-MM-DD') + " "+this.reservationHour+":"+this.reservationMinute
        }
        */

        if(this.isSend != 1) {
          this.showSchedule = false;
        }
        let reservationAt = ""
        if(this.showSchedule) {
          if(!this.reservationDate) {
            this.scheduleErrorMsg="配信日時を設定してください";
            this.loading = false;
            return false;
          }
          reservationAt = moment(this.reservationDate).format('YYYY-MM-DD') + " "+this.reservationHour+":"+this.reservationMinute + ":00"
        }

        
        axios.post('/notifications/'+this.siteId +'/update/'+this.id , {
            id:this.id,
            image:this.image, 
            title:this.title, 
            url:this.url,
            is_test: 0, //this.isTest ? 1 : 0,
            message:this.message, 
            is_send: this.isSend,
            category:this.categorySelected,
            reservation_at:  reservationAt,

          }).then(response => {
            if(response.data && response.data.limit_error) {
              this.limitExceedInfo = {...this.limitExceedInfo, ...response.data.limit_error}
              if(this.limitExceedInfo.doesExceded) {
                this.showLimitModal = true
              }
            }
          if(!reservationAt) {
            this.radio = ""
          }
          this.loading = false;
          //this.info = response.data.info;
          if(response.data.info) {
            this.$toast(response.data.info, {
              toastClassName: "toaster"
            })
          }
        }).catch(error => {
          console.log(error)
          if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
            this.loading = false;
          } else if (error.response.status === 419) {
            alert("ページセッション切りましたので、更新できませんでした。ページをリロードしてください")
          }
        });
      }
    },
  },
}
</script>

<style scoped>
    img {
        max-height: 36px;
    }
    .btn-wrap {
      padding-top:30px;
    }
    select {
    margin: 0 5px;
    }
    .form-check label{
      font-weight:400;
    }
    .form-check {
      float: left;
      margin-right:25px;
    }
   .hour-select {
     max-width:81px;
   }
   .minute-select {
     max-width:110px;
   }
   .date-select{
     max-width:200px;
   }
  select {
    min-width:70px;
  }
  .checkbox-container {
    margin-bottom: 0;
  }
 
   
</style>

